import {
  CURRENCY_FILTER_OPTIONS,
  type CurrencyFilterValue,
} from "../constants/accounts-wallets.constants";
import useTranslations from "@/shared/lang/useTranslations";

type AccountsWalletsFiltersProps = {
  selectedCurrency: CurrencyFilterValue;
  onCurrencyChange: (currency: CurrencyFilterValue) => void;
};

export const AccountsWalletsFilters = ({
  selectedCurrency,
  onCurrencyChange,
}: AccountsWalletsFiltersProps) => {
  const { t } = useTranslations("accountsWallets");
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-thin scrollbar-thumb-slate-300 dark:scrollbar-thumb-zinc-600">
      {CURRENCY_FILTER_OPTIONS.map((currency) => {
        const isAll = currency === "ALL";
        const isSelected = selectedCurrency === currency;
        return (
          <button
            key={currency}
            type="button"
            onClick={() => onCurrencyChange(currency)}
            className={`px-4 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-colors ${
              isSelected
                ? "bg-green-500 text-white dark:bg-green-500 dark:text-white"
                : "bg-white dark:bg-zinc-800 border border-slate-200 dark:border-zinc-600 text-slate-600 dark:text-slate-300 hover:border-green-500 dark:hover:border-green-400"
            }`}
          >
            {isAll ? t("filters_all_currencies") : currency}
          </button>
        );
      })}
    </div>
  );
};
